import { z } from 'zod';
export const chatConversationsQuerySchema = z.object({
    startDate: z.coerce.date().optional(),
    endDate: z.coerce.date().optional(),
    pageSize: z.coerce.number(),
    pageId: z.coerce.number(),
    orderBy: z.enum(['customer_id', 'created_at', 'status', 'integration_type']),
    orderType: z.enum(['asc', 'desc']),
    status: z.string().optional(),
    customerId: z.string().optional(),
    autoQaYesMin: z.coerce.number().int().positive().optional(),
});
